module.exports = __webpack_public_path__ + "resources/img/img_tibero_jp.555e81652b94bb92dd1816a77ade3f1e.png";